import Vue from 'vue'
import App from './App.vue'
import Client from './api/client'

Vue.config.productionTip = false

import VueRouter from "vue-router";
Vue.use(VueRouter)

import Login from "@/views/Login";
import Register from "@/views/Register";

const routes = [
  { path: '/', component: Login },
  { path: '/register', component: Register },
  { path: '/login', component: Login }
]

const token = localStorage.getItem('token')

export const client = new Client(token)

// eslint-disable-next-line no-unused-vars
var app = new Vue({
  router: new VueRouter({mode: 'history', base: window.location.pathname, routes}),
  render: h => h(App),
  data: {
    client
  }
}).$mount('#app')
